import axios from '../modules/AxiosInstance';
import Environment from '../modules/Environment';
import store from '../store';
import UriUtils from '../modules/UriUtils';
import { PAYIT_TENANT_USER_ID, } from '../modules/Constants';

const ServiceOfferingService = (() => {
  const service = {};
  const BASE_URL = `${Environment.getBaseURL()}`;

  const getServiceById = (criteria) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    const queryString = UriUtils.toQueryString(criteria);
    return axios.get(`${BASE_URL}/service-offering/search${queryString}`, {
      headers,
    });
  };

  const getAllServiceOfferings = () => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    return axios.get(`${BASE_URL}/service-offering`, {
      headers,
    });
  };

  service.getServiceById = getServiceById;
  service.getAllServiceOfferings = getAllServiceOfferings;

  return service;
})();

export default ServiceOfferingService;
